import { AxiosInstance, AxiosResponse, AxiosRequestConfig } from 'axios';
import { TCatalog, TCatalogSuggestions, TProductDetail, TRecommendationsResponse } from '../types/catalog';

/**
 * Endpoint for catalog
 */

type TCatalogEndpoints = {
    getCatalogData: (path: string, config?: AxiosRequestConfig) => Promise<AxiosResponse<TCatalog>>;

    getSearch: (query: object) => Promise<AxiosResponse<TCatalog>>;

    getSearchSuggestions: (query: string) => Promise<AxiosResponse<TCatalogSuggestions>>;

    post: (query: object) => Promise<AxiosResponse<TCatalog>>;

    getProductSizeGuideBySku: (sku: string) => Promise<AxiosResponse<string>>;

    getProductDetailsForSkus: (skus: string) => Promise<AxiosResponse<TCatalog>>;

    getProduct: (sku: string, offer?: string) => Promise<AxiosResponse<TProductDetail>>; // #TODO, needs improvement. added for bulk app
    getRecommendations: (event: string, ingest: object) => Promise<AxiosResponse<TRecommendationsResponse>>;
};

export default (api: AxiosInstance): TCatalogEndpoints => {
    const getCatalogData = async (path: string, config?: AxiosRequestConfig): Promise<AxiosResponse<TCatalog>> =>
        api.get<TCatalog>(
            // Get rid of undefined elements
            // Get rid of double slashes
            `${['/_svc/catalog/api/u', path]
                .filter(v => v)
                .join('/')
                .replace(/\/\/+/g, '/')}`,
            config,
        );

    const getSearch = async (query: object): Promise<AxiosResponse<TCatalog>> =>
        api.get<TCatalog>('/_svc/catalog/api/u/search/', {
            params: query,
        });

    const post = async (query: object): Promise<AxiosResponse<TCatalog>> =>
        api.post<TCatalog>('/_svc/catalog/api/search', query);

    const getSearchSuggestions = async (query: string): Promise<AxiosResponse<TCatalogSuggestions>> =>
        api.get<TCatalogSuggestions>(`/_svc/catalog/api/suggestions?q=${encodeURIComponent(query)}`);

    const getProductSizeGuideBySku = async (sku: string): Promise<AxiosResponse<string>> =>
        api.get<string>(`/_svc/sizing-guide/${sku}`);

    const getProductDetailsForSkus = async (skus: string): Promise<AxiosResponse<TCatalog>> =>
        api.get<TCatalog>(`/_svc/catalog/api/search?sku=${skus}`);

    const getProduct = async (sku: string): Promise<AxiosResponse<TProductDetail>> =>
        api.get<TProductDetail>(`/_svc/catalog/api/u/${sku}/p`);

    const getRecommendations = async (
        event: string,
        params: object,
    ): Promise<AxiosResponse<TRecommendationsResponse>> =>
        api.post<TRecommendationsResponse>(`/_svc/recapi/ingest/${event}`, params);

    return {
        getCatalogData,
        getSearch,
        getSearchSuggestions,
        post,
        getProductSizeGuideBySku,
        getProductDetailsForSkus,
        getProduct,
        getRecommendations,
    };
};

type TInternalCatalogEndpoints = {
    getCatalogData: (path: string, config?: AxiosRequestConfig) => Promise<AxiosResponse<TCatalog>>;
};

export const internalCatalog = (api: AxiosInstance): TInternalCatalogEndpoints => {
    const getCatalogData = async (path: string, config?: AxiosRequestConfig): Promise<AxiosResponse<TCatalog>> =>
        api.get<TCatalog>(
            // Get rid of undefined elements
            // Get rid of double slashes
            `${['', path] // set in baseConfig
                .filter(v => v)
                .join('/')
                .replace(/\/\/+/g, '/')}`,
            config,
        );
    return {
        getCatalogData,
    };
};
